/* mm-wissen.js — "Mehr zum Produkt": Sport · Energie · Appetit.
 *
 * 03.09.2026, Mert: "mehr infos zum produkt, sport, energie, appetit, gemixt
 * mit design 21st.dev im produktseite, produktseite unter ugc videos bauen"
 * und "nimm sections von 21st.dev, arbeite mit booksmarks bei 21st.dev".
 *
 * BAUSTEIN: "Elastic Gallery" von @daiwiikharihar, aus Merts eigener
 * 21st-Sammlung "extra features". Ein waagerechtes Bild-Akkordeon: das aktive
 * Feld zieht sich breit und zeigt Text, die anderen bleiben schmal und dunkel.
 * Genau Merts Bauart fuer drei gleichrangige Themen - eine Flaeche mit Wechsel
 * statt drei Karten untereinander.
 *
 * 1:1 UEBERNOMMEN (Optik des Bausteins, nicht angetastet):
 *   flex 4 zu 1 · Uebergang .7s cubic-bezier(.25,1,.5,1) auf flex UND filter ·
 *   Helligkeit 100 aktiv / 50 inaktiv / 75 beim Zeigen · Bildzoom 1.1 -> 1.0
 *   ueber 1s · Verlauf von unten nur im aktiven Feld · Inhalt faehrt 12 Einheiten
 *   hoch mit 200ms Verzoegerung · senkrechte Schrift im schmalen Feld am
 *   Rechner, Nummer am Handy · Radius 16px.
 *
 * UMGESTELLT (Marke und harte Regeln):
 *   Farben auf #151013 / #F3E9EC / #E5142A - kein pinker Text, kein roter
 *   Verlauf als Flaeche. Schriften des Themes. Aus React/Tailwind/next-image
 *   wurde reines JS ohne Bibliothek, weil der Shop kein React hat.
 *   Hoehe 520 (Handy, offenes Feld) / 460 (Rechner) statt 500/600 - Merts PC-Regel.
 *   17.09.2026: Illustrationen mit Menschen und echter Verpackung eingebaut.
 *   Beschriftete Produktbilder bleiben vollstaendig sichtbar (contain).
 *   Bild und Text liegen getrennt, ohne Zoom oder Beschnitt; am Rechner
 *   ist die Bildhoehe auf 360px begrenzt.
 *
 * PLATZ: direkt unter den Creator-Videos (#mmCre). Eine Wache haelt die
 * Sektion dort, falls eine App die Reihenfolge durcheinanderbringt.
 *
 * REIHENFOLGE (Mert, 04.09.2026): Appetit zuerst und offen, dann Energie, dann
 * Sport. Appetit ist der Kern des Produkts und steht deshalb vorne.
 *
 * INHALT: keine Wirkversprechen, keine Kiloangaben, keine Zeitzusagen.
 * "Appetitanreger, kein Mahlzeitersatz" und "keine Garantie" stehen bewusst
 * offen da - das ist Merts Linie.
 */
(function () {
  'use strict';

  var ROT = '#E5142A';
  var K = 'cubic-bezier(.25,1,.5,1)';
  var BASIS = 'https://cdn.shopify.com/s/files/1/0958/0465/3955/files/';

  var THEMEN = [
    {
      s: 'appetit',
      auge: 'Der Kern',
      titel: 'APPETIT',
      bild: BASIS + 'mm-wissen-appetit-illustration-20260917.webp?v=1789607988&width=1000',
      alt: 'Illustration: Frau am Esstisch mit Magic Milk und der echten Verpackung',
      text: 'Magic Milk ist ein Appetitanreger — kein Essen und kein Mahlzeitersatz. ' +
            'Es soll die Lust aufs Essen zurückbringen, den Rest machst du am Tisch. ' +
            'Eine Garantie gibt es nicht, das sagen wir offen. Empfohlen sind ' +
            'mindestens drei Monate.',
      zahlen: ['Appetitanreger', 'kein Mahlzeitersatz', 'ab 3 Monaten']
    },
    {
      s: 'energie',
      auge: 'Durch den Tag',
      titel: 'ENERGIE',
      bild: BASIS + 'mm-wissen-energie-illustration-20260917.webp?v=1789608000&width=1000',
      alt: 'Illustration: Frau trinkt Magic Milk in einer hellen K\u00fcche',
      text: 'Zehn pflanzliche Zutaten und Milchpulver, sonst nichts. Kein Koffein, kein ' +
            'Zuckerschub, kein Aufputschen. Viele beschreiben es als ruhiges, ' +
            'gleichmäßiges Gefühl über den Tag — wie es sich bei dir anfühlt, ' +
            'merkst du selbst.',
      zahlen: ['10 Zutaten', 'ohne Koffein', 'eine Portion am Tag']
    },
    {
      s: 'sport',
      auge: 'Für Sportler',
      titel: 'SPORT',
      bild: BASIS + 'mm-wissen-sport-mann-illustration-20260917.webp?v=1789608016&width=1000',
      alt: 'Illustration: Mann im Fitnessstudio h\u00e4lt die echte Magic-Milk-Verpackung',
      text: 'Wer hart trainiert, verbrennt viel — und muss entsprechend viel essen. ' +
            'Daran scheitern die meisten, nicht am Training. Magic Milk bringt dir selbst ' +
            'kaum Kalorien, sondern soll dir helfen, überhaupt Appetit auf die Menge zu ' +
            'bekommen, die dein Plan verlangt.',
      zahlen: ['30 Portionsbeutel', '5 g je Beutel', 'vor einer Mahlzeit']
    }
  ];

  var css = [
    '#mmWi{background:#151013;color:#F3E9EC;padding:clamp(30px,5vw,54px) 0;',
      'position:relative;overflow:hidden}',
    '#mmWi *{box-sizing:border-box}',
    '#mmWi .mmWiInnen{max-width:1100px;margin:0 auto;padding:0 clamp(14px,3vw,22px)}',
    '#mmWi .mmWiKopf{text-align:center;margin:0 0 clamp(16px,3vw,24px)}',
    '#mmWi .mmWiAuge{display:inline-flex;align-items:center;gap:8px;margin:0 0 10px;',
      'font-size:.62rem;font-weight:800;letter-spacing:.14em;text-transform:uppercase;',
      'color:rgba(243,233,236,.62);opacity:0;transform:translateY(8px);',
      'transition:opacity .5s ' + K + ',transform .5s ' + K + '}',
    '#mmWi .mmWiAuge:before{content:"";width:18px;height:2px;background:' + ROT + ';',
      'transform:scaleX(0);transform-origin:right;transition:transform .5s ' + K + ' .1s}',
    '#mmWi.da .mmWiAuge{opacity:1;transform:none}',
    '#mmWi.da .mmWiAuge:before{transform:scaleX(1)}',
    '#mmWi h2{margin:0;font-size:clamp(1.7rem,4.6vw,2.5rem);line-height:1.04;',
      'letter-spacing:-.02em;font-weight:800;color:#F3E9EC}',
    '#mmWi .mmWiUnter{margin:9px auto 0;max-width:520px;font-size:.85rem;line-height:1.6;',
      'color:rgba(243,233,236,.58)}',

    /* Die Reihe - 1:1 der Baustein: feste Hoehe, damit das Auf- und Zuziehen ruhig laeuft */
    '#mmWi .mmWiReihe{display:flex;flex-direction:column;gap:8px;height:auto}',
    '@media(min-width:760px){#mmWi .mmWiReihe{flex-direction:row;gap:14px;height:460px}}',

    '#mmWi .mmWiFeld{position:relative;overflow:hidden;cursor:pointer;border:0;padding:0;',
      'border-radius:16px;background:#1E1519;width:100%;height:120px;flex:none;',
      'font-family:inherit;text-align:left;color:#F3E9EC;',
      'transition:height .7s ' + K + ',filter .7s ' + K + '}',
    '#mmWi .mmWiFeld[aria-expanded="true"]{height:520px}',
    '@media(min-width:760px){',
      '#mmWi .mmWiFeld{height:100%;width:auto;flex:1 1 0;',
        'transition:flex .7s ' + K + ',filter .7s ' + K + '}',
      '#mmWi .mmWiFeld[aria-expanded="true"]{flex:4 1 0;height:100%}}',
    '#mmWi .mmWiFeld{filter:brightness(.5)}',
    '#mmWi .mmWiFeld[aria-expanded="true"]{filter:brightness(1)}',
    '@media(hover:hover){#mmWi .mmWiFeld:hover{filter:brightness(.75)}',
      '#mmWi .mmWiFeld[aria-expanded="true"]:hover{filter:brightness(1)}}',
    '#mmWi .mmWiFeld:focus-visible{outline:2px solid ' + ROT + ';outline-offset:3px}',

    '#mmWi .mmWiBild{position:absolute;inset:0;width:100%;height:100%;object-fit:contain;',
      /* Am Handy ist das offene Feld fast quadratisch - der Text sass sonst
         auf der Packung. Der Ausschnitt wird deshalb nach oben gezogen,
         damit die Packung oben steht und der Text freien Grund hat. */
      /* Am Rechner sieht man senkrecht nur die mittleren 50 Prozent des Bildes.
         Mit 20 Prozent liegt dieses Fenster bei 0.10 bis 0.60 - genau dort
         sitzen die Packungen in den drei Motiven (Appetit 0.27-0.53,
         Energie 0.21-0.59, Sport 0.13-0.34). Ohne das verschwanden sie im
         dunklen Verlauf. Am Handy ist das Bild senkrecht ganz zu sehen. */
      'object-position:50% 20%;',
      'transform:scale(1.1);transition:transform 1s ' + K + '}',
    '#mmWi .mmWiFeld[aria-expanded="true"] .mmWiBild{transform:scale(1)}',
    '#mmWi .mmWiSchleier{position:absolute;inset:0;opacity:0;transition:opacity .5s ease;',
      'background:linear-gradient(to top,rgba(10,7,9,.8) 0%,rgba(10,7,9,.2) 38%,rgba(10,7,9,0) 78%)}',
    '#mmWi .mmWiFeld[aria-expanded="true"] .mmWiSchleier{opacity:1}',

    '#mmWi .mmWiInhalt{position:absolute;inset:0;display:flex;flex-direction:column;',
      'justify-content:flex-end;padding:clamp(14px,3vw,26px);z-index:2}',
    '#mmWi .mmWiOffen{display:flex;flex-direction:column;gap:8px;',
      'opacity:0;transform:translateY(48px);transition:opacity .5s ease,transform .5s ' + K + '}',
    '#mmWi .mmWiFeld[aria-expanded="true"] .mmWiOffen{opacity:1;transform:none;',
      'transition-delay:.2s}',
    '#mmWi .mmWiPille{align-self:flex-start;border:1px solid rgba(255,255,255,.3);',
      'background:rgba(255,255,255,.12);border-radius:999px;padding:4px 11px;',
      'font-size:.6rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;',
      'color:#fff;-webkit-backdrop-filter:blur(10px) saturate(140%);',
      'backdrop-filter:blur(10px) saturate(140%)}',
    '#mmWi .mmWiTitel{margin:0;font-size:clamp(1.9rem,5.4vw,3rem);line-height:.98;',
      'font-weight:900;letter-spacing:-.01em;text-transform:uppercase;color:#fff}',
    '#mmWi .mmWiText{margin:0;max-width:44ch;font-size:.86rem;line-height:1.6;',
      'color:rgba(255,255,255,.88)}',
    '#mmWi .mmWiZahlen{display:flex;flex-wrap:wrap;gap:7px;margin:4px 0 0;padding:0;list-style:none}',
    '#mmWi .mmWiZahlen li{font-size:.62rem;font-weight:700;letter-spacing:.06em;',
      'text-transform:uppercase;color:rgba(255,255,255,.72);',
      'border:1px solid rgba(255,255,255,.22);border-radius:999px;padding:4px 10px}',

    /* Das schmale Feld: senkrechte Schrift am Rechner, kurze Zeile am Handy */
    '#mmWi .mmWiZu{position:absolute;left:50%;bottom:16px;transform:translateX(-50%);',
      'z-index:2;transition:opacity .5s ease,transform .5s ease;',
      'font-size:.95rem;font-weight:800;letter-spacing:.16em;text-transform:uppercase;',
      'color:#fff;white-space:nowrap}',
    '#mmWi .mmWiFeld[aria-expanded="true"] .mmWiZu{opacity:0;transform:translateX(-50%) scale(.5)}',
    '#mmWi .mmWiFeld[aria-expanded="false"] .mmWiZu{opacity:1;transition-delay:.5s}',
    '@media(min-width:760px){#mmWi .mmWiZu{writing-mode:vertical-rl;bottom:26px;',
      'letter-spacing:.2em}}',

    /* Die neuen 4:3-Illustrationen tragen echte Verpackungsschrift.
       Bild vollstaendig oberhalb des Textes, auch im geschlossenen Feld;
       kein cover, kein Bildzoom und kein Text ueber Person oder Packung. */
    '#mmWi .mmWiFeld{display:flex;flex-direction:column}',
    '#mmWi .mmWiFeld[aria-expanded="true"]{height:auto}',
    '#mmWi .mmWiBild{position:relative;inset:auto;display:block;flex:none;',
      'width:100%;height:auto;aspect-ratio:4/3;object-fit:contain;object-position:center;',
      'transform:none!important}',
    '#mmWi .mmWiSchleier{display:none}',
    '#mmWi .mmWiInhalt{position:relative;inset:auto;display:block;',
      'padding:clamp(16px,3vw,24px);background:#1E1519}',
    '#mmWi .mmWiFeld[aria-expanded="false"] .mmWiInhalt{display:none}',
    '#mmWi .mmWiFeld[aria-expanded="false"] .mmWiBild{width:160px;height:120px}',
    '#mmWi .mmWiFeld[aria-expanded="false"] .mmWiZu{left:auto;right:18px;',
      'top:50%;bottom:auto;transform:translateY(-50%);letter-spacing:.06em}',
    '@media(min-width:760px){#mmWi .mmWiReihe{height:auto;align-items:stretch}',
      '#mmWi .mmWiFeld,#mmWi .mmWiFeld[aria-expanded="true"]{height:auto}',
      '#mmWi .mmWiBild{max-height:360px}',
      '#mmWi .mmWiFeld[aria-expanded="false"] .mmWiBild{width:100%;height:auto}',
      '#mmWi .mmWiFeld[aria-expanded="false"] .mmWiZu{left:50%;right:auto;',
        'top:auto;bottom:26px;transform:translateX(-50%)}}',
    '@media(prefers-reduced-motion:reduce){',
      '#mmWi .mmWiFeld,#mmWi .mmWiBild,#mmWi .mmWiOffen,#mmWi .mmWiSchleier,#mmWi .mmWiZu,',
      '#mmWi .mmWiAuge,#mmWi .mmWiAuge:before{transition:none!important}',
      '#mmWi .mmWiAuge{opacity:1;transform:none}}'
  ].join('');

  function schuetzen(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function bauen() {
    if (document.getElementById('mmWi')) return true;
    var anker = document.getElementById('mmCre');
    if (!anker || !anker.parentNode) return false;

    var st = document.createElement('style');
    st.id = 'mmWi-stil';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);

    var sek = document.createElement('section');
    sek.id = 'mmWi';
    sek.setAttribute('aria-label', 'Mehr zum Produkt');
    sek.innerHTML =
      '<div class="mmWiInnen">' +
        '<div class="mmWiKopf">' +
          '<p class="mmWiAuge">Mehr zum Produkt</p>' +
          '<h2>Wofür die Leute es nehmen</h2>' +
          '<p class="mmWiUnter">Drei Gründe, drei ehrliche Antworten. Tipp eines an, ' +
            'dann klappt es auf.</p>' +
        '</div>' +
        '<div class="mmWiReihe">' +
          THEMEN.map(function (t, i) {
            return '<button class="mmWiFeld" type="button" data-s="' + t.s + '" ' +
              'aria-expanded="' + (i === 0 ? 'true' : 'false') + '">' +
              '<img class="mmWiBild" data-src="' + t.bild + '" alt="' + schuetzen(t.alt) + '" ' +
                'decoding="async" width="1448" height="1086">' +
              '<span class="mmWiSchleier"></span>' +
              '<span class="mmWiZu">' + schuetzen(t.titel) + '</span>' +
              '<span class="mmWiInhalt"><span class="mmWiOffen">' +
                '<span class="mmWiPille">' + schuetzen(t.auge) + '</span>' +
                '<span class="mmWiTitel">' + schuetzen(t.titel) + '</span>' +
                '<span class="mmWiText">' + schuetzen(t.text) + '</span>' +
                '<ul class="mmWiZahlen">' +
                  t.zahlen.map(function (z) { return '<li>' + schuetzen(z) + '</li>'; }).join('') +
                '</ul>' +
              '</span></span>' +
            '</button>';
          }).join('') +
        '</div>' +
      '</div>';

    anker.parentNode.insertBefore(sek, anker.nextSibling);

    var felder = [].slice.call(sek.querySelectorAll('.mmWiFeld'));
    function oeffnen(feld) {
      felder.forEach(function (f) {
        f.setAttribute('aria-expanded', f === feld ? 'true' : 'false');
      });
    }
    felder.forEach(function (f) {
      f.addEventListener('click', function () { oeffnen(f); });
      /* Am Rechner reicht das Zeigen - so macht es der Baustein auch. */
      f.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover:hover)').matches) oeffnen(f);
      });
    });

    function bilderHolen() {
      [].forEach.call(sek.querySelectorAll('.mmWiBild[data-src]'), function (b) {
        b.src = b.getAttribute('data-src');
        b.removeAttribute('data-src');
      });
    }
    if ('IntersectionObserver' in window) {
      /* Zwei Abstaende: die Bilder kommen etwas frueher (400px vorher), damit
         nichts nachlaedt, waehrend man schon hinsieht; die Einblendung erst,
         wenn die Sektion wirklich im Bild ist. */
      new IntersectionObserver(function (e, b) {
        if (!e[0].isIntersecting) return;
        bilderHolen(); b.disconnect();
      }, { rootMargin: '400px 0px' }).observe(sek);
      new IntersectionObserver(function (e, b) {
        if (!e[0].isIntersecting) return;
        sek.classList.add('da'); b.disconnect();
      }, { threshold: 0.15 }).observe(sek);
    } else {
      bilderHolen();
      sek.classList.add('da');
    }
    /* Sicherheitsnetz: liegt die Sektion beim Bauen schon (fast) im Bild, hat der
       Beobachter unter Umstaenden nichts mehr zu melden. Dann einmal selbst
       nachmessen und die Bilder holen - sonst blieben die Felder leer. */
    window.setTimeout(function () {
      var r = sek.getBoundingClientRect();
      if (r.top < window.innerHeight + 600 && r.bottom > -600) {
        bilderHolen();
        sek.classList.add('da');
      }
    }, 1200);

    /* Wache: haelt die Sektion unter den Creator-Videos. Bewusst OHNE
       document.hidden-Abbruch - Platz und Sichtbarkeit sind Aufbau, nicht
       Animation, und im Hintergrund-Tab liefe sie sonst gar nicht. */
    window.setInterval(function () {
      var a = document.getElementById('mmCre');
      var s = document.getElementById('mmWi');
      if (a && s && a.parentNode && a.nextElementSibling !== s) {
        a.parentNode.insertBefore(s, a.nextSibling);
      }
    }, 2500);

    return true;
  }

  function versuchen() {
    if (bauen()) return;
    var n = 0;
    var t = window.setInterval(function () {
      n++;
      if (bauen() || n > 40) window.clearInterval(t);
    }, 700);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', versuchen);
  } else { versuchen(); }
  window.addEventListener('load', versuchen);
})();
